function decapitalizeFirstLetter(text : string) : string {
    return text.charAt(0).toLowerCase() + text.slice(1);
}

export default decapitalizeFirstLetter;